import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import '../styles/Footer.css';
import { FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {

  // ✅ Native Banner Ad
  useEffect(() => {
    const container = document.getElementById("footer-native-ad");

    if (container && !container.hasChildNodes()) {
      container.innerHTML = "";

      const script = document.createElement("script");
      script.src =
        "https://pl29306020.profitablecpmratenetwork.com/43462600380fb661a0d2f51e481cb476/invoke.js";
      script.async = true;

      container.appendChild(script);
    }
  }, []);

  // ✅ 300x250 Ad
  useEffect(() => {
    const container = document.getElementById("footer-300-ad");

    if (container && !container.hasChildNodes()) {
      container.innerHTML = "";

      const atScript = document.createElement("script");
      atScript.innerHTML = `
        atOptions = {
          'key' : '8bdce8107f5b55c14c942175d52eea7e',
          'format' : 'iframe',
          'height' : 250,
          'width' : 300,
          'params' : {}
        };
      `;

      const script = document.createElement("script");
      script.src =
        "https://www.highperformanceformat.com/8bdce8107f5b55c14c942175d52eea7e/invoke.js";
      script.async = true;

      container.appendChild(atScript);
      container.appendChild(script);
    }
  }, []);

  return (
    <footer className="footer">

      <div className="footer-content">

        {/* Brand Section */}
        <div className="footer-section brand-info">
          <h3 className="footer-logo">Job<span>Kickstart</span></h3>

          <p>
            JobKickstart provides the latest job updates for freshers and experienced candidates.
          </p>

          <p className="footer-email">
            📧 Email: jobkickstart.online@gmail.com
          </p>

          {/* Social Icons */}
          <div className="social-logs">

            <a href="https://www.linkedin.com/in/kurubasaipraveen/" className="social-icon" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>

            <a href="https://www.instagram.com/jobfresher.online/" className="social-icon" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>

            <a href="https://whatsapp.com/channel/0029VbCMGpP6WaKv3GTxMe2g" className="social-icon" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>

          </div>

          {/* 🔥 Native Ad */}
          <div id="footer-native-ad" style={{ marginTop: "20px" }}></div>

        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <nav className="footer-links">
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
            <Link to="/terms">Terms & Conditions</Link>
          </nav>
        </div>

        {/* Interview Prep */}
        <div className="footer-section interview-section">
          <h4>Interview Preparation</h4>

          <ul className="footer-links">
            <li><Link to="/html-interview-questions">HTML</Link></li>
            <li><Link to="/css-interview-questions">CSS</Link></li>
            <li><Link to="/javascript-interview-questions">JavaScript</Link></li>
            <li><Link to="/react-js-interview-questions">React.js</Link></li>
            <li><Link to="/node-js-interview-questions">Node.js</Link></li>
            <li><Link to="/sql-interview-questions">SQL</Link></li>
            <li><Link to="/python-interview-questions">Python</Link></li>
            <li><Link to="/git-interview-questions">Git</Link></li>
            <li><Link to="/express-js-interview-questions">Express</Link></li>
          </ul>
        </div>

        {/* Important Info + AD */}
        <div className="footer-section">
          <h4>Important Info</h4>

          <p className="footer-small-text">
            We are not a recruitment agency. We only provide job information collected from official sources.
          </p>

          <p className="footer-small-text">
            Always verify job details before applying.
          </p>

          {/* 🔥 300x250 AD */}
          <script async="async" data-cfasync="false" src="https://pl29306020.profitablecpmratenetwork.com/43462600380fb661a0d2f51e481cb476/invoke.js"></script>
<div id="container-43462600380fb661a0d2f51e481cb476"></div>

        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} JobKickstart. All rights reserved.</p>
      </div>

    </footer>
  );
};

export default Footer;